
import NoteFavorite from "../../../assets/filled/NoteFavorite.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function NoteFavoriteIcon({ className, dataTestid = "NoteFavoriteIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <NoteFavorite data-testid={dataTestid} className={classes} {...rest} />
  );
}
